import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AuthorizeRedirect = () => {
    let { search } = useLocation();
    useEffect(() => {
        // if (window.location.href.includes("bhtik.com")) {
        //     window.location.href = `https://bhtik.com/admin/shops/authorize/redirect${search}`;
        //     return;
        // }
        if (!window.location.href.includes("/admin/shops")) {
            if (window.location.href.includes("/shops/authorize/")) {
                window.location.href = `https://cotik.app/admin/shops/authorize/redirect${search}`;
            } else if (window.location.href.includes("/shops-message/authorize/")) {
                window.location.href = `https://cotik.app/admin/shops-message/authorize/redirect${search}`;
            } else if (window.location.href.includes("/shops-promotion/authorize/")) {
                window.location.href = `https://cotik.app/admin/shops-promotion/authorize/redirect${search}`;
            }
        }
    }, [search]);

    return <></>;
};

export default AuthorizeRedirect;
